module.exports = __webpack_public_path__ + "img/dr.81c6a562.png";